import _ from 'lodash';
import * as yup from 'yup';

export const addVenueSchema = yup.object({
  title: yup
    .string()
    .required('Title is required')
    .matches(
      /^[A-Za-z0-9._~ ]+$/,
      "Title should only contain AlphaNumeric characters, space and '.', '_', '~'"
    )
    .matches(/^\S.*\S$|^\S$/, 'Title sould not have traling spaces'),
  address: yup.string().max(200).required('Venue Address is required'),
  location: yup
    .string()
    .required('Venue Location is required')
    .matches(/^https?:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/, 'Location should be a valid link'),
  city: yup.string().required('City is required'),
  phoneNumber: yup
    .string()
    .required('Phone number is required')
    .matches(/^[0-9]{10}$/, 'Phone number must be a 10-digit number without any special characters'),
  isResourcesLinkedToVenue: yup.bool().required('You need to select this field'),
  packages: yup
    .array(
      yup.object({
        id: yup.string().transform(value => (value === '' ? undefined : value)),
        title: yup.string().required('Package title is required'),
        description: yup.string(),
        price: yup.number().required('Price is required'),
        discount: yup
          .number()
          .min(0, 'Discount should be greater than or equal to 0')
          .max(100, 'Discount should be less than or equal to 100'),
        resources: yup
          .object({
            count: yup.number().test({
              name: 'required',
              message: 'Number of Tickets is Required',
              test: (value, context) => {
                const isResourcesLinkedToVenue = context.from?.at(-1)?.value
                  .isResourcesLinkedToVenue as boolean;
                return isResourcesLinkedToVenue ? value === undefined : value !== undefined;
              }
            })
          })
          .optional()
          .transform(val => (_.isEmpty(val) ? undefined : val))
          .test({
            name: 'resources-forbidden',
            message: 'Resources must not be provided when resources are linked to venue',
            test: (value, context) => {
              const isResourcesLinkedToVenue = context.from?.at(-1)?.value
                .isResourcesLinkedToVenue as boolean;
              return isResourcesLinkedToVenue ? value === undefined || _.isEmpty(value) : value !== undefined;
            }
          }),
        // Conditional validation for resourcesToBook
        resourcesToBook: yup.number().test({
          name: 'resources-forbidden',
          message: 'Resources To Book is Required',
          test: (value, context) => {
            const isResourcesLinkedToVenue = context.from?.at(-1)?.value.isResourcesLinkedToVenue as boolean;
            console.log('resourcesToBook', isResourcesLinkedToVenue, value, context);
            return isResourcesLinkedToVenue ? value !== undefined : value === undefined;
          }
        })
      })
    )
    .min(1)
    .required('Packages are Required')
});

export type AddVenueFormData = yup.InferType<typeof addVenueSchema>;
